export const types = {
  // saas actions types
  GET_EMPLOYEEDATA_REQUEST: "GET_EMPLOYEEDATA_REQUEST",
  GET_EMPLOYEEDATA_SUCCESS: "GET_EMPLOYEEDATA_SUCCESS",
  GET_EMPLOYEEDATA_FAILED: "GET_EMPLOYEEDATA_FAILED",
  
  GET_ALL_INVOICE_REQUEST: "GET_ALL_INVOICE_REQUEST",
  GET_ALL_INVOICE_SUCCESS: "GET_ALL_INVOICE_SUCCESS",
  GET_ALL_INVOICE_FAILED: "GET_ALL_INVOICE_FAILED",

  GET_HOLIDAY_REQUEST: "GET_HOLIDAY_REQUEST",
  GET_HOLIDAY_SUCCESS: "GET_HOLIDAY_SUCCESS",
  GET_HOLIDAY_FAILED: "GET_HOLIDAY_FAILED",
  

  GET_MANAGEPOLICY_REQUEST: "GET_MANAGEPOLICY_REQUEST",
  GET_MANAGEPOLICY_SUCCESS: "GET_MANAGEPOLICY_SUCCESS",
  GET_MANAGEPOLICY_FAILED: "GET_MANAGEPOLICY_FAILED",
  

  GET_CUSTOMER_REQUEST: "GET_CUSTOMER_REQUEST",
  GET_CUSTOMER_SUCCESS: "GET_CUSTOMER_SUCCESS",
  GET_CUSTOMER_FAILED: "GET_CUSTOMER_FAILED",
  

  GET_ASSIGN_ASSET_REQUEST: "GET_ASSIGN_ASSET_REQUEST",
  GET_ASSIGN_ASSET_SUCCESS: "GET_ASSIGN_ASSET_SUCCESS",
  GET_ASSIGN_ASSET_FAILED: "GET_ASSIGN_ASSET_FAILED",
  
  GET_SUPERADMIN_REQUEST: "GET_SUPERADMIN_REQUEST",
  GET_SUPERADMIN_SUCCESS: "GET_SUPERADMIN_SUCCESS",
  GET_SUPERADMIN_FAILED: "GET_SUPERADMIN_FAILED",
  
  GET_COUNTRY_REQUEST: "GET_COUNTRY_REQUEST",
  GET_COUNTRY_SUCCESS: "GET_COUNTRY_SUCCESS",
  GET_COUNTRY_FAILED: "GET_COUNTRY_FAILED",
  
  GET_EMPSALARYDATA_REQUEST: "GET_EMPSALARYDATA_REQUEST",
  GET_EMPSALARYDATA_SUCCESS: "GET_EMPSALARYDATA_SUCCESS",
  GET_EMPSALARYDATA_FAILED: "GET_EMPSALARYDATA_FAILED",
  
  
  GET_REMINDER_REQUEST: "GET_REMINDER_REQUEST",
  GET_REMINDER_SUCCESS: "GET_REMINDER_SUCCESS",
  GET_REMINDER_FAILED: "GET_REMINDER_FAILED",
  
  GET_EMP_LEAVEREQUEST_REQUEST: "GET_EMP_LEAVEREQUEST_REQUEST",
  GET_EMP_LEAVEREQUEST_SUCCESS: "GET_EMP_LEAVEREQUEST_SUCCESS",
  GET_EMP_LEAVEREQUEST_FAILED: "GET_EMP_LEAVEREQUEST_FAILED",
  
  GET_SALARY_REQUEST: "GET_SALARY_REQUEST",
  GET_SALARY_SUCCESS: "GET_SALARY_SUCCESS",
  GET_SALARY_FAILED: "GET_SALARY_FAILED",
  
  GET_EMPLOYEEPROFILE_REQUEST: "GET_EMPLOYEEPROFILE_REQUEST",
  GET_EMPLOYEEPROFILE_SUCCESS: "GET_EMPLOYEEPROFILE_SUCCESS",
  GET_EMPLOYEEPROFILE_FAILED: "GET_EMPLOYEEPROFILE_FAILED",


















  GET_DASHBOARDATA_REQUEST: "GET_DASHBOARDATA_REQUEST",
  GET_DASHBOARDATA_SUCCESS: "GET_DASHBOARDATA_SUCCESS",
  GET_DASHBOARDATA_FAILED: "GET_DASHBOARDATA_FAILED",

  GET_DEMOREQUEST_REQUEST: "GET_DEMOREQUEST_REQUEST",
  GET_DEMOREQUEST_SUCCESS: "GET_DEMOREQUEST_SUCCESS",
  GET_DEMOREQUEST_FAILED: "GET_DEMOREQUEST_FAILED",

  GET_PLANHISTORY_REQUEST: "GET_PLANHISTORY_REQUEST",
  GET_PLANHISTORY_SUCCESS: "GET_PLANHISTORY_SUCCESS",
  GET_PLANHISTORY_FAILED: "GET_PLANHISTORY_FAILED",

  GET_SERVICETYPE_REQUEST: "GET_SERVICETYPE_REQUEST",
  GET_SERVICETYPE_SUCCESS: "GET_SERVICETYPE_SUCCESS",
  GET_SERVICETYPE_FAILED: "GET_SERVICETYPE_FAILED",

  GET_PLANS_REQUEST: "GET_PLANS_REQUEST",
  GET_PLANS_SUCCESS: "GET_PLANS_SUCCESS",
  GET_PLANS_FAILED: "GET_PLANS_FAILED",

  GET_COMPANIES_REQUEST: "GET_COMPANIES_REQUEST",
  GET_COMPANIES_SUCCESS: "GET_COMPANIES_SUCCESS",
  ADD_COMPANIES_SUCCESS: "ADD_COMPANIES_SUCCESS",
  UPDATE_COMPANIES_SUCCESS: "UPDATE_COMPANIES_SUCCESS",
  GET_COMPANIES_FAILED: "GET_COMPANIES_FAILED",

  GET_RECENT_TRANSACTION_REQUEST: "GET_RECENT_TRANSACTION_REQUEST",
  GET_RECENT_TRANSACTION_REQUEST_SUCCESS: "GET_RECENT_TRANSACTION_REQUEST_SUCCESS",
  GET_RECENT_TRANSACTION_REQUEST_FAILED: "GET_RECENT_TRANSACTION_REQUEST_FAILED",

  GET_PENDING_DEMO_REQUEST: "GET_PENDING_DEMO_REQUEST",
  GET_PENDING_DEMO_REQUEST_SUCCESS: "GET_PENDING_DEMO_REQUEST_SUCCESS",
  GET_PENDING_DEMO_REQUEST_FAILED: "GET_PENDING_DEMO_REQUEST_FAILED",

  GET_PURCHASE_SUMMARY_REQUEST: "GET_PURCHASE_SUMMARY_REQUEST",
  GET_PURCHASE_SUMMARY_SUCCESS: "GET_PURCHASE_SUMMARY_SUCCESS",
  GET_PURCHASE_SUMMARY_FAILED: "GET_PURCHASE_SUMMARY_FAILED",





  GET_RECENT_REGISTRATIONS_REQUEST: "GET_RECENT_REGISTRATIONS_REQUEST",
  GET_RECENT_REGISTRATIONS_REQUEST_SUCCESS: "GET_RECENT_REGISTRATIONS_REQUEST_SUCCESS",
  GET_RECENT_REGISTRRATIONS_REQUEST_FAILED: "GET_RECENT_REGISTRRATIONS_REQUEST_FAILED",


  GET_PLAN_EXPIRE_REQUEST: "GET_PLAN_EXPIRE_REQUEST",
  GET_PLAN_EXPIRE_REQUEST_SUCCESS: "GET_PLAN_EXPIRE_REQUEST_SUCCESS",
  GET_PLAN_EXPIRE_REQUEST_FAILED: "GET_PLAN_EXPIRE_REQUEST_FAILED",
  
  


 
};
